import React, { useEffect } from 'react'
import Signup from "./Components/Signup";
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom'

import Login from './Components/Login'
import Dashboard from "./Components/Dashboard";
import Navbar from "./Components/Navbar";
import ProtectedLoginRoute from './ProtectedRoute/ProtectedLoginRoute'
import ProtectedSignupRoute from "./ProtectedRoute/ProtectedSignupRoute";
import ProtectedUserRoute from "./ProtectedRoute/ProtectedUserRoute";
import UserProfile from "./Components/UserProfile";


function App() {
  useEffect(() => {
    document.title = "Degram"
  }, [])




  return (
    <div>

      <Router>
        <Navbar />



        <Switch>
          <Route path="/" exact component={Dashboard}></Route>

          <ProtectedSignupRoute path="/signup" component={Signup}></ProtectedSignupRoute>
          <ProtectedLoginRoute path="/login" component={Login}></ProtectedLoginRoute >
          <ProtectedUserRoute exact path="/user" component={UserProfile}></ProtectedUserRoute>

        </Switch>
      </Router>


    </div>

  );
}

export default App;
